import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import PasswordResetCompletion from './components/PasswordResetCompletion';
import ErrorBoundary from './components/ErrorBoundary';
import ToastContainer from './components/ToastContainer';
import NetworkStatus from './components/NetworkStatus';
import LoadingSpinner from './components/LoadingSpinner';

function AppContent() {
  const { user, loading } = useAuth();
  
  // Debug logging as requested
  console.log('[AppContent] Render:', { loading, user: user?.id || 'null', timestamp: new Date().toISOString() });

  // Show loading spinner while auth is initializing
  if (loading) {
    console.log('[AppContent] Still loading, showing spinner');
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner size="lg" className="mx-auto mb-4" />
          <p className="text-gray-600">Loading your experience...</p>
          <p className="text-xs text-gray-400 mt-2">Debug: Auth loading state</p>
        </div>
      </div>
    );
  }

  console.log('[AppContent] Loading complete, showing main app');

  return (
    <Router>
      <Routes>
        <Route 
          path="/reset-password" 
          element={<PasswordResetCompletion />} 
        />
        <Route 
          path="/" 
          element={user ? <Dashboard /> : <LandingPage />} 
        />
      </Routes>
      <ToastContainer />
      <NetworkStatus />
    </Router>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;